<template>
  <div class="animated fadeInRight ecommerce">
    <el-row>
      <el-col :span="24">
        <el-card>
          <div slot="header" class="clearfix flex justify-between">
            <h5>查询条件</h5>
          </div>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-input
                v-model="auditUserManageInfo.conditions.auditUserId"
                placeholder="请输入审核ID"
                clearable
              />
            </el-col>
            <el-col :span="6">
              <el-input
                v-model="auditUserManageInfo.conditions.userName"
                placeholder="请输入审核人员"
                clearable
              />
            </el-col>
            <el-col :span="6">
              <el-select
                v-model="auditUserManageInfo.conditions.auditLink"
                placeholder="请选择审核环节"
                style="width:100%"
              >
                <el-option label="请选择审核环节" value="" />
                <el-option label="部门主管" value="809001" />
                <el-option label="财务主管" value="809002" />
                <el-option label="采购人员" value="809003" />
              </el-select>
            </el-col>
            <el-col :span="6">
              <el-button type="primary" @click="_queryAuditUserMethod">
                <i class="el-icon-search"></i> 查询
              </el-button>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="24">
        <el-card>
          <div slot="header" class="clearfix flex justify-between">
            <h5>审核人员信息</h5>
            <el-button
              type="primary"
              size="small"
              @click="_openAddAuditUserModal"
            >
              <i class="el-icon-plus"></i>
              添加
            </el-button>
          </div>
          <el-table
            :data="auditUserManageInfo.auditUsers"
            border
            style="width: 100%"
          >
            <el-table-column prop="auditUserId" label="审核ID" align="center" />
            <el-table-column prop="userId" label="用户ID" align="center" />
            <el-table-column prop="userName" label="用户名称" align="center" />
            <el-table-column
              prop="auditLinkName"
              label="审核环节"
              align="center"
            />
            <el-table-column
              prop="objCodeName"
              label="流程对象"
              align="center"
            />
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="small"
                  @click="_openDeleteAuditUserModel(scope.row)"
                >
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-size="pageSize"
            layout="total, prev, pager, next"
            :total="auditUserManageInfo.total"
          />
        </el-card>
      </el-col>
    </el-row>

    <delete-audit-user ref="deleteAuditUser" @refresh="_listAuditUsers" />
  </div>
</template>

<script>
import { listAuditUsers } from '@/api/common/auditUserApi'
import DeleteAuditUser from '@/components/common/deleteAuditUser/deleteAuditUser.vue'

export default {
  name: 'AuditUserManage',
  components: {
    DeleteAuditUser
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      auditUserManageInfo: {
        auditUsers: [],
        total: 0,
        records: 1,
        conditions: {
          auditUserId: '',
          userName: '',
          auditLink: '',
          page: 1,
          row: 10
        }
      }
    }
  },
  created() {
    this._listAuditUsers(this.currentPage, this.pageSize)
  },
  methods: {
    handleCurrentChange(val) {
      this.currentPage = val
      this._listAuditUsers(val, this.pageSize)
    },
    async _listAuditUsers(page, rows) {
      this.auditUserManageInfo.conditions.page = page
      this.auditUserManageInfo.conditions.row = rows
      try {
        const res = await listAuditUsers(this.auditUserManageInfo.conditions)
        this.auditUserManageInfo.total = res.total
        this.auditUserManageInfo.records = res.records
        this.auditUserManageInfo.auditUsers = res.auditUsers
      } catch (error) {
        console.error('获取审核人员列表失败:', error)
      }
    },
    _openAddAuditUserModal() {
      this.$router.push('/pages/common/addAuditUserStep')
    },
    _openDeleteAuditUserModel(auditUser) {
      this.$refs.deleteAuditUser.open(auditUser)
    },
    _queryAuditUserMethod() {
      this.currentPage = 1
      this._listAuditUsers(this.currentPage, this.pageSize)
    }
  }
}
</script>

<style scoped>
.ecommerce {
  padding: 20px;
}
.el-row {
  margin-bottom: 20px;
}
.el-card {
  margin-bottom: 20px;
}
</style>